import Vue from "vue";
import { Component, Emit, Prop } from "vue-property-decorator";

@Component({
    name: 'EditModal',
    components: {
        Edit: require('../edit.vue.html').default
    }
})
export default class EditModal extends Vue {
    @Prop({ required: true })
    modalId!: string;
    @Prop({ required: true })
    data!: { id: number, name: string };

    forceOpen(): void {
        eval('$("#' + this.modalId + '").modal("show")');
    }

    forceClose(): void {
        eval('$("#' + this.modalId + '").modal("hide")');
    }

    @Emit('save')
    save(): void {

    }

    get canSave(): boolean {
        return !!this.data.name;
    }
}
